export const GET_PERSONA_OGG = 'GET_PERSONA_OGG';

/**
 * Get persona dati privati.
 * @function getPersonaOgg
 * @returns {Object} Get persona oggetto results action.
 */
export function getPersonaOgg(path) {
  return {
    type: GET_PERSONA_OGG,
    path,
    request: {
      op: 'get',
      path: `${path}/@getPersonaObj`,
    },
  };
}